const endpoints = {
    base: 'https://hubpoc.tnc.org/api'
};

export const environment = {
    production: false,
    name: 'Hub (POC)',
    endpoints,
    algolia: {
        appId: 'WRFJJH1WEP',
        portfolioSearch: {
            indexName: 'poc_hub4_portfoliosearch',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/poc_hub4_portfoliosearch`
        },
        projectNameSearch: {
            indexName: 'poc_hub4_projectnames',
            routing: false,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/poc_hub4_projectnames`
        },
        collectionSearch: {
            indexName: 'poc_hub4_projectcollectionsearch',
            routing: false,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/poc_hub4_projectcollectionsearch`
        },
        fundraisingMenuSearch: {
            indexName: 'poc_hub4_fundraisingmenu',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/poc_hub4_fundraisingmenu`
        },
        userAdministration: {
            indexName: 'poc_hub4_user',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/poc_hub4_user`
        },
        projectAtTncSearch: {
            indexName: 'css_poc_projectsattnc',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/css_poc_projectsattnc`
        }
    },
    auth: {
        tenant: '79be6dc1-d78e-4bbb-b22b-d994c0a417a7',
        clientId: 'a0680fbb-f6c4-4652-b439-6b2636b4141a',
        redirectUri: 'https://hubpoc.tnc.org/auth-callback',
        domain: 'hubpoc.tnc.org',
        requireHttpsProtocol: true,
        endpoints: {
            'https://localhost/61642': '767fb58b-cde9-42b1-8881-44665d5a9c81',
            'https://localhost/8080': '767fb58b-cde9-42b1-8881-44665d5a9c81'
        }
    },
    errorHandling: {
        display: {
            autohide: {
                delayInSeconds: 3
            },
            showStackTrace: true
        },
        logging: null
    },
    arcGISOnlineApiKey: '',
    showNonProdNotification: true,
    appInsights: {
        connectionString: 'InstrumentationKey=01123c71-f83b-4a6f-85f3-011ea00ebe73;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/'
    },
    timers: {
        showWarningBeforeTimeoutInMinutes: 5
    },
    amCharts: {
        license: 'CH304356357'
    },
    featureToggles: {}
};
